export const GUEST_TOKEN = process.env.REACT_APP_GUEST_TOKEN;
